import { PlusOutlined } from "@ant-design/icons";
import { clientApi } from "@api";
import {
  ComponentPagination,
  SearchFilter,
  SelectedFilter,
  StyledListPage,
  ComponentHeader,
  StyledInnerListPage,
  SharedButton,
  SharedIconButton,
  PlusIcon,
  DownloadV2,
} from "@components";

import { PATH_PRODUCT_CREATE, productFilter, enumFilter, initPage } from "@configs";
import { IPagination, IRedeemCoupon } from "@interfaces";
import { ProductTable } from "@modules";
import { selectApp, setLoading } from "@redux";
import { useNotify } from "@utils";
import { Tooltip } from "antd";

import { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

export const PageProduct = () => {
  // hook
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const { success, error } = useNotify();
  const { mobile } = useSelector(selectApp);
  // state
  const [page, setPage] = useState<IPagination>(initPage);
  const [total, setTotal] = useState<number>(0);
  const [data, setData] = useState<IRedeemCoupon[]>([]);
  const [filters, setFilters] = useState<enumFilter | string>("");
  const [text, setText] = useState<string>("");
  const [date, setDate] = useState<string[]>([]);

  useEffect(() => {
    fetchClient();
  }, [page, text, date]);

  const fetchClient = async () => {
    try {
      dispatch(setLoading(true));
      const res = await clientApi.clients({
        page: page.page,
        limit: page.limit,
        searchColumn: filters,
        search: text,
        startDate: date[0],
        endDate: date[1],
      });
      setData(res.data?.data);
      setTotal(res.data?.nTotal);
      success(t("message.fetch.success"));
    } catch (err: any) {
      error(t("message.fetch.fail"));
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };
  const handleDateFilter = (dates: null | (Dayjs | null)[], dateStrings: string[]) => {
    setDate(dateStrings);
  };
  const handlePagination = (current: number, size: number) => {
    setPage({ ...page, page: current, limit: size });
  };

  const goToCreate = () => history.push(PATH_PRODUCT_CREATE);
  const changeFilter = (value: string) => setFilters(value);
  const searchText = (value: string) => setText(value);
  const handleClearSearch = () => {
    setText("");
    setFilters("");
  };
  const handleClearDate = () => setDate([]);
  const handleDownloadCsv = async () => {
    try {
      const { data } = await clientApi.export({
        searchColumn: filters,
        search: text,
        startDate: date[0],
        endDate: date[1],
      });
      const url = window.URL.createObjectURL(new Blob([data], { type: `text/csv` }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Exported client records");
      link.click();
      window.URL.revokeObjectURL(url);
      success(t("message.download.success"));
    } catch (err: any) {
      error(t("message.download.fail"));
      throw new Error(err);
    }
  };
  const button = (
    <>
      <Tooltip title={t("page.download_excel")}>
        <SharedButton
          type="primary"
          icon={<DownloadV2 />}
          size="middle"
          onClick={handleDownloadCsv}
          style={{ background: "#00AA67", color: "#fff" }}
        >
          {t("page.download")}
        </SharedButton>
      </Tooltip>
      <Tooltip title={t("page.add_client")}>
        {mobile ? (
          <SharedIconButton type="primary" ghost icon={<PlusIcon />} onClick={goToCreate} />
        ) : (
          <SharedButton
            type="primary"
            ghost
            icon={<PlusOutlined />}
            size="middle"
            onClick={goToCreate}
          >
            {t("page.add_new_product")}
          </SharedButton>
        )}
      </Tooltip>
    </>
  );
  return (
    <>
      <ComponentHeader title={t("page.product_master")} />
      <StyledListPage>
        <StyledInnerListPage>
          <SearchFilter
            actionBtn={button}
            filter={productFilter}
            callbackFun={changeFilter}
            onDateChange={handleDateFilter}
            searchText={searchText}
            searchInputPlaceholder={t("page.search_user_by")}
            selectedOption={filters}
          />
          <SelectedFilter
            handleClearSearch={handleClearSearch}
            handleClearDate={handleClearDate}
            selected={filters}
            formDate={date[0]}
            toDate={date[1]}
          />
          <ProductTable data={data} callback={fetchClient} />
          <ComponentPagination total={total} page={page.page} changePage={handlePagination} />
        </StyledInnerListPage>
      </StyledListPage>
    </>
  );
};
